/**
 * Created by zhaoyao
 * Desc:访客拜访通知详情
 */

import React, {Component} from 'react'
import {connect} from 'react-redux';
import {Toast} from 'antd-mobile'
import {fetchGet, fetchPost} from "../../../utils/fetchRequest";
import {_host, API} from "../../../configs/api.config";
import moment from 'moment';
import {Button} from "antd";
import {getArrayValue, getIntValue, getSearchParams, getStrValue, isObjEmpty} from "../../../utils/common";
import './VisitorDetail.css'

class VisitorDetail extends Component {

    constructor() {
        super()

        this.state = {
            id: 0,
            teacherId: 0,
            name: '',
            reason: '',
            visitTime: '',
            mobile: '',
            visitType: '',
            showButton:false,
            AMvisible: false,
            AMTitle:null,
            handleStatus:null //审批操作1:同意，2：拒绝
        }
    }

    componentDidMount() {
        document.title = '访客拜访通知'
        this.anId = this.props.match.params.anId

        this.getVisitDetail()
    }

    componentWillUnmount() {
        Toast.hide()
    }

    render() {
        const {name, reason, visitTime, mobile, visitType} = this.state

        return (
            <div className="common-column-layout" style={{fontFamily:"PingFangSC-Regular",letterSpacing:2.5}}>
                <div className="item_sty" style={{padding: '6px 15px', background: '#f7f7f7'}}>
                    <div className="left_title">拜访记录</div>
                    <div className="left_title">{visitType == 1 ? '已拜访' : visitType == 2 ? '已过期' : '未拜访'}</div>
                </div>

                <div className="comhline_sty1"></div>

                <div className="item_sty">
                    <div className="left_title">拜访人员:</div>
                    <div className="left_title">{name}</div>
                </div>

                <div className="comhline_sty1"></div>

                <div className="item_sty">
                    <div className="left_title">拜访人电话:</div>
                    <div className="left_title">{mobile}</div>
                </div>

                <div className="comhline_sty1"></div>

                <div className="item_sty">
                    <div className="left_title">拜访时间:</div>
                    <div className="left_title">{visitTime}</div>
                </div>

                <div className="comhline_sty1"></div>

                <div className="item_sty">
                    <div className="left_title">拜访缘由:</div>
                    <div className="left_title">{reason}</div>
                </div>

                <div className="comhline_sty"></div>

                {/*<div>
                    <textarea  ref='faultReason' className="form-control textarea_sty" rows="4"
                               placeholder="回复" maxLength={100}></textarea>
                </div>*/}

                <div className="comhline_sty"></div>

                {/*<Button className='commonButton' type='primary' style={{margin: '35px',borderRadius:30}}
                        onClick={this.onSubmitClick}>同意</Button>
                <Button className='commonButton' type='primary' style={{margin: '35px',borderRadius:30}}
                        onClick={this.onSubmitClick}>拒绝</Button>*/}

                {this.state.showButton ? <div style={{display:'flex',flexDirection:'row',marginBottom:20}} >
                    <div style={{width:'50%',textAlign:'center'}}>
                        <Button  type="primary" className="agree_sty" onClick={() => this.handleStatusClick(1)}>同意</Button>
                    </div>
                    <div style={{width:'50%',textAlign:'center'}}>
                        <Button className="disagree_sty" onClick={() => this.handleStatusClick(0)}>拒绝</Button>
                    </div>
                </div> : ''}
            </div>
        )
    }

    handleStatusClick(event){
        var statusTitle = null
        if(event == 1){
            statusTitle = '同 意'
        }else if(event == 0){
            statusTitle = '拒 绝'
        }
        this.setState({
            AMvisible: false,
            AMTitle:statusTitle,
            handleStatus:event
        });

        /*if (this.state.faultReason == null || this.state.faultReason == '') {
            Toast.fail('请填写损坏描述');
            return
        }*/

        const params = {
            teacherId:this.state.teacherId,
            id:this.props.match.params.anId,
            status: event,
        };

        fetchPost(API.VISIT_RECORD_AUDIT, params, {}).then((response) => {
            if (response.success) {
                Toast.show(response.data, 1);
                this.setState({
                    showButton:false
                })
                this.backTask = setTimeout(() => {
                    this.props.history.goBack()
                }, 1000)
            }
        }).catch((error) => {
            console.log('error', error);
            if (typeof error === 'string') {
                Toast.fail(error, 2)
            } else {
                Toast.fail('请求异常', 2)
            }
        })
    };

    getVisitDetail() {
        Toast.show('', 0)

        fetchGet(API.VISIT_RECORD_DETAIL + '/' + this.anId, {})
            .then(response => {
                Toast.hide()

                if (response && response.data) {
                    let data = response.data

                    this.setState({
                        id: getIntValue(data, 'id'),
                        teacherId: getIntValue(data, 'visitorId'),
                        name: getStrValue(data, 'name'),
                        reason: getStrValue(data, 'reason'),
                        visitTime: getStrValue(data, 'visitTime'),
                        mobile: getStrValue(data, 'mobile'),
                        visitType: getStrValue(data, 'visitStatus'),
                        showButton: getIntValue(data, 'statusType') !== null && (getIntValue(data, 'statusType') === 1 || getIntValue(data, 'statusType') === 2) ? false : true,
                    })
                }
            })
            .catch(error => {
                Toast.hide()

                if (typeof error === 'string') {
                    Toast.fail(error, 2)
                } else {
                    Toast.fail('请求异常', 2)
                }
            })
    }
}


let mapStateToProps = (state) => ({
    userInfo: {...state.redUserInfo}
})

let mapDispatchToProps = (dispatch) => ({})

export default connect(mapStateToProps, mapDispatchToProps)(VisitorDetail)
